import React, { useRef, useState } from 'react';
import HomeSearchBanner from '../homeSearchbanner';
import { useDispatch } from 'react-redux';
import ProductSection from '../productSection';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { Link } from 'react-router';
import { routePrefix } from '@/utils/routes/routes';
import { setActiveCustomerTab } from '@/core/redux/commonSlice';
import HomePageFooter from '../homePageFooter';
import Header5 from '@/feature-module/common/header/header-5';
import MenuHeader from '@/feature-module/common/menuHeader';

const HomeThemeFive = (props: any) => {
  const { themeData, collections } = props;
  const [quantities, setQuantities] = useState<{ [key: number]: number }>({});

  const dispatch = useDispatch();
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const handleQuantityChange = (productId: number, newValue: number) => {
    setQuantities((prev) => ({ ...prev, [productId]: newValue }));
  };

  const handleAddToCart = (productId: number) => {
    console.log(
      `Added product ${productId} to cart with quantity ${quantities[productId] || 1}`
    );
  };

  const handleAddToWishlist = (productId: number) => {
    console.log(`Added product ${productId} to wishlist`);
  };

  const handleQuickView = (productId: number) => {
    console.log(`Quick view for product ${productId}`);
  };
  return (
    <>
      {/* <Header5 themeData={themeData} /> */}
      {/* <MenuHeader /> */}
      <div className="wrapper">
        <section className="banner-area v3 pt-0 mb-3">
          <div className="banner-container">
            <HomeSearchBanner themeData={themeData} />
          </div>
        </section>
        {/* {collections.map((data) => {
          if (!data?.data?.length) return null;
          const commonProps = {
            products: data.data,
            onQuantityChange: handleQuantityChange,
            onAddToCart: handleAddToCart,
            onAddToWishlist: handleAddToWishlist,
            onQuickView: handleQuickView,
          };

          if (data.product_category_title) {
            return (
              <ProductSection
                key={data.id}
                title={data.product_category_title}
                layout="grid"
                showNavigation={data.product_category_type === 'slider'}
                {...commonProps}
              />
            );
          }

          if (data.category_slider_title || data.brand_slider_title) {
            return (
              <section
                key={data.id}
                className="category-tab-section mb-2 mb-md-4"
              >
                <div className="container">
                  <div className="sec-hdr d-flex align-items-center">
                    <h3>
                      {data.category_slider_title || data.brand_slider_title}
                    </h3>
                    <div className="category-navigation ms-auto d-flex align-items-center">
                      <div
                        className="category-button-prev"
                        ref={prevRef}
                        role="button"
                        aria-label="Previous slide"
                      >
                        <MdKeyboardArrowLeft />
                      </div>
                      <div
                        className="category-button-next"
                        ref={nextRef}
                        role="button"
                        aria-label="Next slide"
                      >
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </div>

                  <Swiper
                    modules={[Navigation]}
                    spaceBetween={30}
                    slidesPerView="auto"
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      if (
                        typeof swiper.params.navigation !== 'boolean' &&
                        swiper.params.navigation
                      ) {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                      }
                    }}
                    className="category-slider-wrapper"
                  >
                    {data?.data?.map((category, index) => (
                      <SwiperSlide key={index} style={{ width: '178px' }}>
                        <Link
                          to={{
                            pathname: `${routePrefix}/category/${category?.id}`,
                          }}
                          state={{ type: category?.type }}
                          onClick={() =>
                            dispatch(
                              setActiveCustomerTab(
                                category.name || category.title
                              )
                            )
                          }
                        >
                          <div className="category-container">
                            <div className="category-container-img">
                              <img
                                loading="lazy"
                                className="category-img"
                                src={`${category?.image_path}${category?.image}`}
                                alt={category.name || category.title}
                              />
                            </div>
                            <div className="category-name">
                              {category.name || category.title}
                            </div>
                          </div>
                        </Link>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </section>
            );
          }

          if (
            data.product_collection_title &&
            data.product_collection_type === 'gallery'
          ) {
            return (
              <ProductSection
                key={data.id}
                title={data.product_collection_title}
                layout="grid"
                showNavigation={data.product_category_type === 'slider'}
                {...commonProps}
              />
            );
          }
          return null;
        })} */}
      </div>
      <div className="row">
        <HomePageFooter themeData={themeData} />
      </div>
    </>
  );
};

export default HomeThemeFive;
